import $ from "jquery";

require("./main/helpers");
require("./main/header");
require("./main/footer");
require("./main/carousels");
// require('./main/reviews');
require("./main/collections");
require("./main/product");
require("./main/gwp_function");
require("./main/blog-list");
require("./main/pagination");
require("./main/accounts");
require("./main/cart");
require("./main/video");
require("./main/swatches");
